import CheckBox from '../CheckBox/CheckBox';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import Stack from '../Stack/Stack';
import styles from './CheckboxWithLabel.module.scss';
import type { CheckboxWithLabelProps } from './types';

const CheckboxWithLabel = ({
  checked,
  onChange,
  errorMessage,
  id,
  label,
  ...props
}: CheckboxWithLabelProps) => {
  return (
    <div className={styles.base}>
      <div className={styles.checkboxRow}>
        <Stack flexDirection="row" gap="1rem">
          <CheckBox id={id} checked={checked} onChange={onChange} {...props} />

          <label htmlFor={id} className={styles.text}>
            {label}
          </label>
        </Stack>

        {errorMessage && (
          <ErrorMessage hasRelativePosition>{errorMessage}</ErrorMessage>
        )}
      </div>
    </div>
  );
};

export default CheckboxWithLabel;
